import { FC } from 'react';
import { Text } from '@react-pdf/renderer';
import styles from './styles';

interface ShareConsiderationFootnoteProps {
  totalShareConsideration?: {
    amount: number;
    formatted: string;
  };
  isLossSection?: boolean;
}

const ShareConsiderationFootnote: FC<ShareConsiderationFootnoteProps> = ({
  totalShareConsideration,
  isLossSection = false,
}) => {
  if (!totalShareConsideration || totalShareConsideration.amount <= 0) {
    return null;
  }

  return (
    <Text style={styles.paragraph}>
      Realisations denoted with a (§) have received share consideration in
      addition to the cash consideration above. Total share consideration value
      received in this tax year is {totalShareConsideration.formatted}. This is
      not taxable in the UK until subsequent sale
      {isLossSection ? ' but does reduce any claimable loss' : ''}. For further
      information, see the applicable exit or loss statement.
    </Text>
  );
};

export default ShareConsiderationFootnote;
